import JSZip from 'jszip';
import { CommonJsBundler } from 'libs.template_engine';
import { consentZipArtifacts } from './consent_zip_artifacts.generated';
const ES_MODULE_INTEROP = 'Object.defineProperty(exports, "__esModule", { value: true });\n';
function loadModule(moduleJs, requireImpl) {
    const moduleRef = { exports: {} };
    new Function('require', 'module', 'exports', moduleJs)(requireImpl, moduleRef, moduleRef.exports);
    return moduleRef.exports;
}
function loadFunctionRenderer(moduleJs, dependencies) {
    const requireFn = (name) => {
        const mod = dependencies[name];
        if (mod === undefined) {
            throw new Error(`Can't find module ${name}. Missing in zip renderer dependencies?`);
        }
        return mod;
    };
    return loadModule(moduleJs, requireFn);
}
function base64ToUint8Array(base64) {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}
/**
 * Axon `i18n.*.content.zip` layout: `index.html`, `bundle.js`, `hooks.js`, and `assets/*`
 * (see `templates.react.app` + `TemplateLoader` / `bundleExport` in `libs.templates.utils`).
 * Built from the compiled {@link ConsentCompiledBundle} (manifest + `page.js` / `form.js` / PDF) so the
 * download matches deployable HTML bundles, not the raw Step-7 flat package.
 */
export async function buildConsentI18nContentZip(bundle) {
    const { prebuiltInnerModules, outer } = consentZipArtifacts;
    const { frameworkPageJs, reactAppJs, indexHtml, hooksJs } = outer;
    const pdfUrlKey = `./${bundle.pdfFileName}?url`;
    const assetPath = `assets/${bundle.pdfFileName}`;
    // Match `loadSubBundlesDependencies` + inner bundle: assets/`*.?url` before `consent` main (`form.js` requires it).
    const innerModules = {
        'i18n.language': `${ES_MODULE_INTEROP}exports.default = 'en-US';\n`,
        'i18n.rtl': `${ES_MODULE_INTEROP}exports.default = false;\n`,
        ...prebuiltInnerModules,
        [pdfUrlKey]: `${ES_MODULE_INTEROP}exports.default = '${assetPath}';\n`,
        'consent': bundle.formJs,
    };
    const innerBundleString = new CommonJsBundler().bundle(innerModules);
    const pdfBytes = base64ToUint8Array(bundle.pdfBase64);
    const consentDep = {
        default: () => ({
            bundle: innerBundleString,
            assets: { [assetPath]: pdfBytes },
        }),
        __esModule: true,
    };
    const reactAppExport = loadFunctionRenderer(reactAppJs, {
        'i18n.language': { default: 'en-US', __esModule: true },
        'i18n.rtl': { default: false, __esModule: true },
        './index.html': { default: indexHtml, __esModule: true },
    });
    const frameworkPageExport = loadFunctionRenderer(frameworkPageJs, {
        'templates.react.app~1_0': reactAppExport,
        './hooks.js': { default: hooksJs, __esModule: true },
    });
    const rootExport = loadFunctionRenderer(bundle.pageJs, {
        'templates.consent.framework.page~1_0': frameworkPageExport,
        'consent': consentDep,
    });
    const files = rootExport.default();
    const zip = new JSZip();
    for (const [filePath, content] of Object.entries(files)) {
        if (content instanceof Uint8Array || typeof content === 'string') {
            zip.file(filePath, content);
        }
        else {
            throw new Error(`Unsupported content for ${filePath}: ${typeof content}`);
        }
    }
    return zip.generateAsync({ type: 'blob' });
}
